import { Link } from "react-router-dom";
import type { Post } from "../../lib/posts";
import { formatDate } from "../../lib/date";
import { CategoryBadge } from "../taxonomy/CategoryBadge";
import { TagList } from "../taxonomy/TagList";
import { FeaturedImage } from "./FeaturedImage";

type ArticleCardProps = {
  post: Post;
};

export function ArticleCard({ post }: ArticleCardProps) {
  return (
    <article className="article-card">
      <Link className="article-card__image" to={post.url} aria-label={post.title}>
        <FeaturedImage src={post.featuredImage} alt="" loading="lazy" />
      </Link>
      <div className="article-card__body">
        <div className="article-card__meta">
          <CategoryBadge category={post.category} />
          <time dateTime={post.publishedAt}>{formatDate(post.publishedAt)}</time>
        </div>
        <h2>
          <Link to={post.url}>{post.title}</Link>
        </h2>
        <p>{post.excerpt}</p>
        <TagList tags={post.tags.slice(0, 4)} />
      </div>
    </article>
  );
}
